module.exports = __webpack_public_path__ + "img/ck4.bb0a84d9.png";